import * as ng from "@angular/core";
import { AngularFireRemoteConfig } from '@angular/fire/remote-config';
import { Subject } from "rxjs";
import { RemoteConfigValue } from "./entity/remote-config";

@ng.Injectable()
export class mag2RemoteConfig {
  private remoteConfigPrefix = "is_aws_mode";
  private remoteConfigPrefix2 = "change_broadcast_target_delay_time_sec";
  private castifyMode = "0";
  private awsMode = "1";

  // 1回sbusctibeしたら何度もsubsctibeしないようにこちらを使用する
  public fetchedIsAwsValue: boolean | undefined;
  public fetchedDelayTimeValue: string | undefined;

  private remoteValue: Subject<RemoteConfigValue> = new Subject();
  private isAwsFlg: Subject<boolean> = new Subject();
  private endBroadcastDelayTime: Subject<string> = new Subject();

  constructor(
    private remoteConfig: AngularFireRemoteConfig
  ) {}

  /**
   * awsかcastifyかを切り替えるbool値を取得する
   */
  getIsAwsValue(): Subject<boolean> {
    this.getStrings(this.remoteConfigPrefix).subscribe(
      val => {
        if (val[this.remoteConfigPrefix] === this.castifyMode) {
          this.isAwsFlg.next(false);
          this.fetchedIsAwsValue = false;
        } else if(val[this.remoteConfigPrefix] === this.awsMode) {
          this.isAwsFlg.next(true);
          this.fetchedIsAwsValue = true;
          this.outputLogs();
        } else {
          console.error('[RemoteConfig] An unexpected error has occurred');
          throw new Error();
        }
      },
      error => console.log(`onError: ${error}`),
      () => console.log('[RemoteConfig] getIsAwsValue completed')
    )
    return this.isAwsFlg;
  }

  /**
   * 配信終了時と公開設定切り替え時に、配信停止を遅延する秒数を取得する
   */
  getEndBroadcastDelayTime(): Subject<string> {
    this.getStrings(this.remoteConfigPrefix2).subscribe(
      val => {
        if (val[this.remoteConfigPrefix2]) {
          this.endBroadcastDelayTime.next(val[this.remoteConfigPrefix2]);
          this.fetchedDelayTimeValue = val[this.remoteConfigPrefix2];
        } else {
          this.fetchedDelayTimeValue = val[this.remoteConfigPrefix2];
        }
      },
      error => console.log(`onError: ${error}`),
      () => console.log('[RemoteConfig] getEndBroadcastDelayTime completed')
    )
    return this.endBroadcastDelayTime;
  }

  private getStrings(prefix): Subject<RemoteConfigValue> {
    this.remoteConfig.strings.subscribe(
      val => {
        if (val[prefix]) {
          this.remoteValue.next(val);
        }
      },
      error => console.log(`[RemoteConfig] onError: ${error}`),
      () => console.log('[RemoteConfig] getStrings completed')
    )
    return this.remoteValue;
  }

  // remote congigの状態確認用
  private outputLogs() {
    this.remoteConfig.settings.then(x => {
      console.log('[RemoteConfig] minimumFetchIntervalSec : ' + x.minimumFetchIntervalMillis / 1000 + 'sec');
    })
    this.remoteConfig.lastFetchStatus.then(x => {
      console.log('[RemoteConfig] lastFetchStatus : ' + x);
    })
    this.remoteConfig.fetchTimeMillis.then(timestamp => {
      const date = new Date(timestamp);
      console.log(
        '[RemoteConfig] last fetch time : ' +
        date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate()+' '+date.getHours()+':'+date.getMinutes()
      );
    })
  }
}